import { initializeApp, getApps, deleteApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

let dynamicApp = null;
let dynamicDB = null;

export const initDynamicFirebase = async (config) => {
    // Deleta app anterior, se existir
    if (dynamicApp) {
        await deleteApp(dynamicApp);
    }

    const existingApps = getApps();
    existingApps.forEach(app => deleteApp(app));

    dynamicApp = initializeApp(config, 'dynamicApp');
    dynamicDB = getFirestore(dynamicApp);
    return dynamicDB;
};
